import { render, staticRenderFns } from "./RatingsInProgressWidget.vue?vue&type=template&id=b2988d38&scoped=true"
import script from "./RatingsInProgressWidget.vue?vue&type=script&lang=js"
export * from "./RatingsInProgressWidget.vue?vue&type=script&lang=js"
import style0 from "./RatingsInProgressWidget.vue?vue&type=style&index=0&id=b2988d38&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2988d38",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2988d38')) {
      api.createRecord('b2988d38', component.options)
    } else {
      api.reload('b2988d38', component.options)
    }
    module.hot.accept("./RatingsInProgressWidget.vue?vue&type=template&id=b2988d38&scoped=true", function () {
      api.rerender('b2988d38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/RatingsInProgressWidget.vue"
export default component.exports